import { useState } from 'react';
import { FormTitle, TextArea } from '@molecules/TextArea/TextArea';
import { NavigationButtons } from '@molecules/TextArea/TextArea';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../../../../routes/Routes';
import { usePlanningBreachStore } from '../../../../hooks/usePlanningBreachStore';
import { ErrorMessages } from '@types';
import { parseZodErrors, TextAreaFlexibleLengthSchema } from '@utils';
import { ZodError } from 'zod';
import { ErrorSummary } from '@atoms/ErrorSummary/ErrorSummary';
import { TEXT_AREA_MAX_LENGTH } from '@constants';

const specificLocationLabelText = 'What condition has been breached?';
const specificLocationDescription =
  'List all the conditions being breached. For example, work is only allowed from 8am to 6pm.';

const howConditionBreachedLabelText = 'How is the condition being breached?';
const howConditionBreachedDescription =
  'For example, windows being opened in breach of a condition.';

export const TellUsMoreBreach = () => {
  const { data, update } = usePlanningBreachStore();
  const navigate = useNavigate();
  const formTitle = 'Tell us about the issue';
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);

  const handleChangeLocationOfIssueInfo = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    update('locationOfIssueInfo', event.currentTarget.value);
    setErrorMessages([]);
  };

  const handleChangeHowConditionBreached = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    update('howConditionBreached', event.currentTarget.value);
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      try {
        const validation = {
          fieldNames: ['locationOfIssueInfo', 'howConditionBreached'],
          maxLength: TEXT_AREA_MAX_LENGTH,
          minLength: 1,
          minLengthMessage: 'Enter details about the issue',
        };
        TextAreaFlexibleLengthSchema(validation).parse({
          locationOfIssueInfo: data.locationOfIssueInfo,
          howConditionBreached: data.howConditionBreached,
        });

        navigate(RoutesList.BREACH_PROBLEM);
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    label: 'Previous',
    onClick: () => navigate(RoutesList.PLANNING_PERMISSON),
  };

  return (
    <>
      <FormTitle text={formTitle} />
      <ErrorSummary messages={errorMessages} />
      <TextArea
        labelText={specificLocationLabelText}
        isLabelTextTitle={false}
        description={specificLocationDescription}
        value={data.locationOfIssueInfo}
        onChange={handleChangeLocationOfIssueInfo}
        errorPath={'locationOfIssueInfo'}
        errorMessages={errorMessages}
      />
      <TextArea
        labelText={howConditionBreachedLabelText}
        isLabelTextTitle={false}
        description={howConditionBreachedDescription}
        value={data.howConditionBreached}
        onChange={handleChangeHowConditionBreached}
        errorPath={'howConditionBreached'}
        errorMessages={errorMessages}
      />
      <NavigationButtons
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
      />
    </>
  );
};
